import { DataTableSkeleton } from '@/components/data-table/data-table-skeleton';
import GridChargePointsSkeleton from '@/modules/charge-center/skeleton-components/grid-charge-points-skeleton';

const GridConnectionsSkeleton = ({ type }: { type: 'chargers' | 'connectors' }) => {
  return (
    <div className="$tw-w-full $tw-rounded-md $tw-bg-background">
      {type === 'chargers' ? (
        <GridChargePointsSkeleton />
      ) : (
        <DataTableSkeleton
          dateFilters={false}
          showViewOptions={false}
          customToolbar={false}
          columnCount={5}
          rowCount={10}
          withPagination={false}
        />
      )}
    </div>
  );
};

export default GridConnectionsSkeleton;
